export const homeFaqs = [
  {
    question: "What is Headlockr?",
    answer:
      "Headlocks is a multifactor authentication plugin built for Strapi. It supports multiple authentication methods, including SMS, email, TOTP, passkeys, and backup codes. It's plug and play, easy to use, and highly customizable. Headlockr protects your admin panel and content API from unauthorized access and data breaches.",
  },
  {
    question: "How do I install Headlockr?",
    answer:
      "To install Headlockr, you need to download the plugin via npm and install it in your Strapi project. To download the software you'll need a valid license. After installation you can configure the plugin settings and enable the authentication methods you want. We have dedicated documentation at https://docs.headlockr.io/ with step-by-step guides.",
  },
  {
    question: "Does Headlockr support passkeys?",
    answer:
      "Yes. Headlockr 5 adds passkey support for modern, phishing-resistant authentication flows in Strapi. Passkeys integrate alongside existing MFA methods and fit naturally into the admin authentication experience.",
  },
  {
    question: "What are MFA enforcement policies?",
    answer:
      "MFA enforcement policies let administrators require MFA for specific roles, define which factors are allowed during enrollment, and optionally configure a grace period before enforcement becomes mandatory.",
  },
  {
    question: "Does Headlockr support password expiration and breached-password detection?",
    answer:
      "Yes. Headlockr can enforce password expiration after a configured number of days and can check passwords against the Have I Been Pwned breach corpus during login to help identify compromised credentials.",
  },
  {
    question: "Do I still need to edit vite.config.js in Headlockr 5?",
    answer:
      "No. Starting with Headlockr 5.0.0, the plugin integrates natively with Strapi and no longer requires the older Vite configuration changes. If you upgrade from an older version, remove the previous custom Vite-related Headlockr setup.",
  },
  {
    question: "What is MFA?",
    answer:
      "MFA stands for Multi-Factor Authentication. It is a security feature that requires more than one method of authentication from independent categories of credentials to verify the user's identity for a login or other transaction.",
  },
  {
    question: "How does MFA work?",
    answer:
      "MFA works by requiring two or more of the following authentication methods: something you know, something you have, or something you are.",
  },
  {
    question: "What if I lose my MFA device?",
    answer:
      "If you lose access to your MFA device, you can use backup codes to regain access to your account. Make sure to store your backup codes in a safe place. If you also lose those, contact your administrator or customer support.",
  },
  {
    question: "What is the difference between MFA and 2FA?",
    answer:
      "MFA stands for Multi-Factor Authentication and can require two or more methods of authentication. 2FA stands for Two-Factor Authentication and specifically requires two methods from different credential categories.",
  },
];

export const pricingFaqs = [
  {
    question: "Is there a money-back guarantee?",
    answer:
      "Yes, you have a 7-day money-back guarantee on your purchase. This allows you to evaluate HeadLockr risk-free after purchase.",
  },
  {
    question: "How long does this agreement last?",
    answer:
      "As long as the subscription you choose. A yearly subscription is renewed annually. Subscriptions are automatically renewed unless canceled.",
  },
  {
    question: "Can I change my subscription later?",
    answer:
      "Yes, but at the moment we do not have an automatic upgrade or downgrade option for that. It will be added to the portal soon to help you manage your subscription with self service.",
  },
  {
    question: "Which plans include passkeys and advanced security policies?",
    answer:
      "Passkeys are included from the Developer plan. MFA enforcement policies and password expiration policies are included in the Agency plan.",
  },
  {
    question: "Do I need extra Vite configuration with Headlockr 5?",
    answer:
      "No. Headlockr 5 integrates natively with Strapi, so the older Vite configuration is no longer required.",
  },
  {
    question: "Can I purchase HeadLockr for my company?",
    answer:
      "Absolutely. If you need multiple licenses for your company, please contact us for a custom quote.",
  },
  {
    question: "Will I receive an invoice for my purchase?",
    answer:
      "Yes, you will receive an invoice for your purchase, including the specified VAT amount for your country by email.",
  },
];
